module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tuneMic":"Setup your microphone","micSettingsCheck":"Setup your microphone before the interview"}}')
  delete Component.options._Ctor
}
